const { CaseType } = require("../../../../constants/caseType");
const {
  getSafeTubeInfoTextPerLanguage,
} = require("../../../../utils/productUtil/productUtil");

const getProductWarnings = (
  t,
  product,
  caseType,
  productReturn,
  lang,
  productFieldName
) => {
  const {
    safeTubeNeededInReturning,
    isDamageProductReturnRequired,
    isReturnable,
    isAnesthetics,
    safeTubeInfoText,
  } = product || {};

  const customerIsReturningProduct = productReturn?.returnValue;
  const shouldShowNonReturnableWarning =
    isReturnable === false &&
    customerIsReturningProduct === true &&
    caseType === CaseType.PRODUCT_DELIVERY &&
    productFieldName !== "missingProduct";

  const newWarnings = [];

  // safe tube warning
  if (
    (safeTubeNeededInReturning === true || safeTubeInfoText?.length > 0) &&
    caseType === CaseType.SUSPECTED_PRODUCT_DEFECT
  ) {
    if (safeTubeInfoText?.length > 0) {
      const safeTubeInfoTextInLang = getSafeTubeInfoTextPerLanguage(
        safeTubeInfoText,
        lang
      );
      newWarnings.push({
        id: "safe-tube-warning-text",
        text: safeTubeInfoTextInLang?.value || t("safeTubeInfo"),
      });
    } else {
      newWarnings.push({
        id: "safe-tube-warning-text",
        text: t("safeTubeInfo"),
      });
    }
  }

  // Damaged product return required
  if (
    isDamageProductReturnRequired === true &&
    customerIsReturningProduct === false &&
    caseType === CaseType.DAMAGED_PRODUCT
  ) {
    newWarnings.push({
      id: "damaged-product-return-required-text",
      text: t("damagedProductReturnRequiredWarning"),
    });
  }

  // non returnable
  if (shouldShowNonReturnableWarning) {
    newWarnings.push({
      id: "non-returnable-text",
      text: t("nonReturnableProductWarning"),
    });
  }

  // Anesthetics
  if (isAnesthetics === true && customerIsReturningProduct === true) {
    newWarnings.push({
      id: "anesthetics-text",
      text: t("anestheticsWarning"),
    });
  }

  return newWarnings;
};

module.exports = { getProductWarnings };
